import styles from './Toast.module.css'

interface IToast {
  message: string
  type: 'success' | 'error'
  visible: boolean
}

const Toast: React.FC<IToast> = ({ message, type }) => {
  return (
    <div className={`${styles.toast} ${styles[type]}`}>
      <span>{message}</span>
    </div>
  )
}

export default Toast
